import { InputTypes } from 'Components-redesign/Form/fieldTypes';

export const getCategoryFormFields = (
  t,
  idToUpdate,
  activatedFeatures,
  categoriesList,
  coursetypeList,
  showUkVatRate,
) => [
  {
    id: 'nameLang',
    additionalFieldToUpdate: 'name',
    label: t('General.Name'),
    placeHolder: t('PIM.NamePlaceholder'),
    type: InputTypes.TEXTLANG,
    mandatory: true,
  },
  (activatedFeatures.hasAppOrders || activatedFeatures.hasExpress) && {
    id: 'descriptionLang',
    additionalFieldToUpdate: 'description',
    label: t('General.Description'),
    placeHolder: t('PIM.DescriptionPlaceholer'),
    type: InputTypes.TEXTAREALANG,
  },
  categoriesList.length > 0 && {
    id: 'parentId',
    label: t('PIM.ParentCategory'),
    placeHolder: t('PIM.CategoryPlaceholder'),
    type: InputTypes.SELECT,
    list: categoriesList,
    customMutation: (value) => {
      const val = value?.id ?? value ?? '';
      if (val.length < 1) {
        return '';
      } else {
        return value;
      }
    },
    width: 50,
  },
  coursetypeList.length > 0 &&
    activatedFeatures.hasTables && {
      id: 'courseType',
      label: t('PIM.CourseType'),
      placeHolder: t('PIM.CourseTypePlaceholder'),
      type: InputTypes.SELECT,
      list: coursetypeList,
      customMutation: (val) => {
        if (val?.id?.length == 0) {
          return { disconnect: true };
        } else if (val?.length == 0 || val == undefined) {
          return;
        } else {
          return { connect: { id: val } };
        }
      },
      width: 50,
    },
  {
    id: 'vatRate',
    label: t('PIM.Vat'),
    placeHolder: t('PIM.VatPlaceholder'),
    mandatory: true,
    value: '',
    width: 100,
    type: InputTypes.SELECTVAT,
    disabled: idToUpdate ? true : false,
    information: idToUpdate ? t('PIM.Vat.Information') : undefined,
  },
  showUkVatRate && {
    id: 'ukVatRate',
    label: t('PIM.TakeAwayVat'),
    placeHolder: t('PIM.VatPlaceholder'),
    value: '',
    width: 100,
    ignoreInMutation: true,
    type: InputTypes.SELECTVAT,
  },
  activatedFeatures.hasPOS && {
    id: 'color',
    label: t('PIM.ColorForPos'),
    width: 100,
    placeHolder: t('PIM.ColorForPosPlaceholder'),
    type: InputTypes.SELECTCOLOR,
  },
  activatedFeatures.hasAppOrders && {
    id: 'hideInCustomerOrderingFlows',
    label: t('PIM.HideInCustomerOrdering'),
    type: InputTypes.TOGGLE,
  },
  {
    id: 'order',
    label: t('PIM.Order'),
    placeHolder: t('PIM.OrderPlaceholder'),
    type: InputTypes.INT,
    validation: (value) => value > 0,
    validationMessage: t('PIM.OrderValidation'),
  },
  (activatedFeatures.hasAppOrders || activatedFeatures.hasExpress) && {
    id: idToUpdate ? 'image' : 'imageId',
    label: t('PIM.Image'),
    type: InputTypes.IMAGESELECT,
  },
];
